/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2022-03-04 18:15:04
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import getters from './getters'
import GroupingList from './modules/GroupingList'
import dashboard from './modules/dashboard'
import device from './modules/device'
import monitorDevice from './modules/cloudMonitor/device'
import monitorTerminal from './modules/cloudMonitor/terminal'
import variable from './modules/cloudMonitor/variable'
import cancelToken from './modules/cancelToken'
import keepAlive from './modules/keepalive'
export default new Vuex.Store({
    modules: {
        GroupingList,
        dashboard,
        device,
        cancelToken,
        monitorDevice,
        monitorTerminal,
        variable,
        keepAlive,
    },
    getters
})